import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

const ComparisonBarChart = ({
  title,
  metricKey,
  zomatoData = [],
  swiggyData = [],
  isCurrency
}) => {

  // 🔥 Merge both arrays by period

  if ( !swiggyData.length || !zomatoData.length){
     return 
  }  


  const data = (zomatoData || []).map((zMonth) => {
    const sMonth = swiggyData && (swiggyData || []).find(
      (s) => s.period === zMonth.period
    );
  
    return {
      period: zMonth.period,
      zomato: zMonth?.[metricKey] || 0,
      swiggy: sMonth?.[metricKey] || 0,
    };
  });
  
  const formatValue = (value) => {
    if (isCurrency) return `₹${value.toLocaleString()}`;
    return value.toLocaleString();
  };

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <h2 className="text-lg font-semibold mb-4">{title}</h2>

      <ResponsiveContainer width="100%" height={350}>
        <BarChart data={data}>
          <CartesianGrid stroke="#e5e7eb" strokeDasharray="3 3" />

          <XAxis dataKey="period" />
          <YAxis tickFormatter={formatValue} />

          <Tooltip formatter={formatValue} />
          <Legend />

          <Bar
            dataKey="zomato"
            fill="#EF4F5F"
            radius={[6, 6, 0, 0]}
            name="Zomato"
            animationDuration={800}
          />

          <Bar
            dataKey="swiggy"
            fill="#FC8019"
            radius={[6, 6, 0, 0]}
            name="Swiggy"
            animationDuration={800}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ComparisonBarChart;
